import '../sass/main.scss';

// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
import { initAll } from 'govuk-frontend';
import 'flatpickr/dist/flatpickr.min';
import 'magnific-popup/dist/jquery.magnific-popup.min';

document.addEventListener('DOMContentLoaded', () => {
    initAll();
});

//Load Modules
import './modules/advancedFilters';
import './modules/memberEdit';
import './modules/menu';
import './modules/searchToggle';
import './modules/sliders';